import { Button } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { VscChromeClose } from 'react-icons/vsc';

export const RemoveBtn = ({ children, ...restProps }: { children: ReactNode; [key: string]: any }) => {
  return (
    <Button
      variant='linkUnderline'
      color='gray.400'
      leftIcon={<VscChromeClose />}
      fontSize='xs'
      fontWeight={500}
      sx={{ '>span': { marginInlineEnd: '.1rem' } }}
      {...restProps}
    >
      {children}
    </Button>
  );
};
